import { SxProps } from "@mui/material";

export const pickStoreBtnSx:SxProps = {
    maxWidth: '25%', 
    px: 1, 
    py: 0.5, 
    fontSize: 14
}

export const storeStockAvailabilitySX:SxProps = {
    flexDirection:"row",
    alignItems:"center",
    columnGap:0.5,
    minWidth: '60%'
}